
import React from 'react';

export const DraftingCompassIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <circle cx="12" cy="5" r="1" />
    <path d="m12 5 4 14" />
    <path d="m12 5-4 14" />
    <path d="M19.07 15.42A8.5 8.5 0 0 1 12 20a8.5 8.5 0 0 1-7.1-4.66" />
  </svg>
);
